import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/Hero";
import { Intro } from "../components/Intro";
import { ProjectFlow } from "../components/ProjectFlow";
import { Marquee } from "../components/Marquee";
import { Experience, Education } from "../components/Timeline";
import { Contact } from "../components/Contact";
import { Testimonials } from "../components/Testimonials";
import { scrollToTarget } from "../lib/smooth";

let introPlayed = false;

export default function Home() {
  const { hash } = useLocation();
  const first = !introPlayed && !hash;
  useEffect(() => {
    introPlayed = true;
  }, []);
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); return undefined; }
    const t = setTimeout(() => scrollToTarget(hash, { immediate: true }), 120);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <main data-testid="home-page">
      {first && <Intro />}
      <Hero delay={first ? 1.35 : 0.1} />
      <ProjectFlow />
      <Marquee />
      <Experience />
      <Education />
      <Testimonials />
      <Contact />
    </main>
  );
}
